import kitchenJson from '@inmoment/the-kitchen/package.json';

export type SemanticVersion = `${number}.${number}.${number}`;

export const kitchenVersion: SemanticVersion = kitchenJson.version as SemanticVersion;

export function compareVersions(a: SemanticVersion, b: SemanticVersion): -1 | 0 | 1 {
  if (a === b) {
    return 0;
  }

  const aParts = a.split('.');
  const bParts = b.split('.');

  while (aParts.length || bParts.length) {
    const a = Number(aParts.shift());
    const b = Number(bParts.shift());

    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    }
  }

  return 0;
}

export const semverGreaterThan = (versionA: SemanticVersion, versionB: SemanticVersion) => compareVersions(versionA, versionB) === 1;
